var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M3 3h18v4H3V3zm1 5h16v13H4V8zm5.5 3a.5.5 0 00-.5.5V13h6v-1.5a.5.5 0 00-.5-.5h-5z",
  id: "icon_svg__a"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon_svg__c",
  d: "M0 0h24v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2 2h20v20H2z"
}), /*#__PURE__*/React.createElement("mask", {
  id: "icon_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#icon_svg__a"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#icon_svg__b)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "icon_svg__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#icon_svg__c"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#icon_svg__d)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}))))));

export default SvgIcon;